export const TimeOption = {
  flow: 'y', align: 'center center', padding: 'Y Z', round: 'Z', background: 'inkMid', border: '1px solid inkBorder', cursor: 'pointer', gap: 'W',
  transition: 'all 0.15s ease',
  isSelected: (el, s) => s.root.selectedTime === s.label,
  '.isSelected': { background: '#0D1117', color: '#FFFFFF', borderColor: '#0D1117' },
  ':hover': { borderColor: '#0D1117' },
  onClick: (e, el, s) => s.root.update({ selectedTime: s.label }),
  TimeLabel: { text: (el, s) => s.label, fontSize: 'Z', fontWeight: '600' },
  TimePeriod: { text: (el, s) => s.period, fontSize: 'Y', color: 'inkMuted' }
}
